import { NotificationSlice } from "./notifications-slice";

export {
  getAllNotificationsThunk,
  addNewNotificationThunk,
  triggerNotificationThunk,
  deleteNotificationThunk,
} from "slices/notifications/notifications-thunks";

export default NotificationSlice.reducer;

export const { setCurrentNotificationReducer, setCurrentPageReducer } =
  NotificationSlice.actions;
